'use client';
import { useArSpaceNavigation } from '@/hooks/useArSpaceNavigation';

export default function Layout({ children }: { children: React.ReactNode }) {
  useArSpaceNavigation(); // 啟動自動監聽紀錄
  return <>{children}</>;
}
